module.exports = __webpack_public_path__ + "static/bsas008.thumb-5d06104525441849191e773421181bc7.jpg";